// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/bp.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@keyframes upDown {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0);
  }
}
main,
.fuel {
  display: flex;
  flex-direction: column;
  background-color: #e4ffff;
  min-height: 62.1vh;
  width: 100%;
  margin: auto;
  align-items: center;
  justify-content: flex-start;
}
main #context__menu,
.fuel #context__menu {
  display: none;
  color: #fff;
  background-color: #2c53a0;
  width: 9vw;
}
main #context__menu ul,
.fuel #context__menu ul {
  list-style-type: none;
}
main #context__menu ul li,
.fuel #context__menu ul li {
  cursor: pointer;
}
main #context__menu ul li:hover,
.fuel #context__menu ul li:hover {
  transform: scale(1.2);
  transition: 0.5s;
}
main h1,
.fuel h1 {
  font-size: 2rem;
}
main .select_row,
.fuel .select_row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 60vw;
  margin: 0 auto;
}
main .select_row .Compile_Done,
.fuel .select_row .Compile_Done {
  background-color: #71a621;
  color: #fff;
}
main .select_row .Compile__Error,
.fuel .select_row .Compile__Error {
  background-color: #f29f05;
  color: #fff;
}
main .select_row select,
.fuel .select_row select {
  width: 25%;
  padding: 1%;
  border-radius: 1rem;
  background-color: #fff;
}
main .select_row select:focus,
.fuel .select_row select:focus {
  border: 1px solid #64c4e0;
}
main .select_row input[type=date],
.fuel .select_row input[type=date] {
  border: none;
  background-color: #fff;
  border-radius: 1rem;
  height: 4vh;
}
main #loader,
.fuel #loader {
  align-self: center;
  margin: 2% auto;
}
main .info,
.fuel .info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1%;
  width: 100vw;
  overflow: hidden;
}
main .info .info__card,
.fuel .info .info__card {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  width: 80vw;
  border-radius: 1rem;
  height: 11vh;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: relative;
  margin-bottom: 2%;
}
main .info .info__card .card__till,
.fuel .info .info__card .card__till {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
main .info .info__card .card__till h3,
.fuel .info .info__card .card__till h3 {
  color: #4d4d4d;
  margin: 0 auto;
}
main .info .info__card .info__card__icon,
.fuel .info .info__card .info__card__icon {
  position: absolute;
  right: 2%;
  bottom: 1.5%;
  animation: upDown 1.5s infinite;
  -webkit-animation: upDown 1.5s infinite;
}
main .info .info__button,
.fuel .info .info__button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
}
main .info .info__button .info__expand,
.fuel .info .info__button .info__expand {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  width: 95vw;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  margin-top: 2%;
}
main .info .info__button .info__expand .compiled,
.fuel .info .info__button .info__expand .compiled {
  border: 3px solid #22ff69;
}
main .info .info__button .info__expand table,
.fuel .info .info__button .info__expand table {
  border: 1px solid #4d4d4d;
  border-collapse: collapse;
  width: 100%;
  color: #4d4d4d;
}
main .info .info__button .info__expand table .compiled,
.fuel .info .info__button .info__expand table .compiled {
  border: 3px solid #22ff69;
}
main .info .info__button .info__expand table thead th,
.fuel .info .info__button .info__expand table thead th {
  background-color: #2c53a0;
  color: #fff;
}
main .info .info__button .info__expand table tbody tr,
.fuel .info .info__button .info__expand table tbody tr {
  border: 1px solid #4d4d4d;
  cursor: pointer;
}
main .info .info__button .info__expand table tbody .noteAdded,
.fuel .info .info__button .info__expand table tbody .noteAdded {
  background-image: linear-gradient(225deg, red, red 10px, transparent 10px, transparent);
}
main .info .info__button .info__expand table tbody .selected,
.fuel .info .info__button .info__expand table tbody .selected {
  background-color: #f2bc18;
}
main .info .info__button .info__expand table tbody .matched,
.fuel .info .info__button .info__expand table tbody .matched {
  background-color: #22ff69;
}
main .info .info__button .info__expand table tbody .matchedDiscrepancy,
.fuel .info .info__button .info__expand table tbody .matchedDiscrepancy {
  background-color: #038c3e;
  color: #fff;
}
main .info .info__button .info__expand table tbody .notmatched,
.fuel .info .info__button .info__expand table tbody .notmatched {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  background-color: #d90d1e;
  color: #fff;
}
main .info .info__button .info__expand table tbody .bp__points,
.fuel .info .info__button .info__expand table tbody .bp__points {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 5%;
  background-repeat: no-repeat;
  background-position-x: right;
}
main .info .info__button .info__expand table tbody .ignored,
.fuel .info .info__button .info__expand table tbody .ignored {
  background-color: #5d5d5d;
  color: #fff;
}
main .info .info__button button,
.fuel .info .info__button button {
  margin-top: 1%;
}
main .info .info__button .help__icon,
.fuel .info .info__button .help__icon {
  position: fixed;
  bottom: 4vh;
  right: 3vw;
  z-index: 10;
}
main .info .info__button .tiny__loader,
.fuel .info .info__button .tiny__loader {
  width: 10%;
  margin: 2% auto 0 auto;
}

.css-19kzrtu {
  padding: 0px !important;
}

.suspended_fuel {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  text-align: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  padding: 0 2vw;
  width: 100%;
  margin-top: 1vh;
}
.suspended_fuel .suspend_card {
  cursor: pointer;
  width: 28vw;
  background-color: white;
  border-radius: 5px;
  height: 20vh;
  display: flex;
  flex-direction: column;
}
.suspended_fuel .suspend_card h3 {
  color: #2c53a0;
  font-size: 2rem;
  margin: 0;
}
.suspended_fuel .suspend_card:hover {
  background-color: #64c4e0;
}

.suspend_modal .header_info {
  display: flex;
  justify-content: space-evenly;
}
.suspend_modal .header_info span {
  color: #2c53a0;
}
.suspend_modal .transaction_accordians {
  max-height: 60vh;
  overflow-y: auto;
}
.suspend_modal .transaction_accordians .no_transactions {
  color: #2c53a0;
}
.suspend_modal .transaction_accordians .transaction_accordian.Mui-disabled {
  background-color: rgb(255, 255, 255);
}
.suspend_modal .transaction_accordians .transaction_accordian .transaction_heading span {
  color: #2c53a0;
  font-weight: 700;
}

.tender_modal {
  display: flex;
  flex-direction: column;
}
.tender_modal .modal_content {
  margin: 10px;
  font-size: 1.2rem;
  text-align: center;
  font-weight: 500;
}
.tender_modal .alert_section {
  height: 6vh;
}
.tender_modal .btn_section {
  display: flex;
  justify-content: space-around;
}
.tender_modal .btn_section button {
  width: 200px;
}

.force__match {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.force__match p {
  margin: 0;
  color: #4d4d4d;
}
.force__match select {
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
}
.force__match .force__buttons {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 80%;
  margin: auto;
  margin-top: 1%;
}
.force__match .force__buttons table {
  color: #4d4d4d;
}
.force__match table {
  width: 100%;
  margin: auto;
  border: 1px solid #4d4d4d;
  border-collapse: collapse;
}
.force__match table thead {
  background-color: #2c53a0;
  color: #fff;
}
.force__match table tbody tr,
.force__match table tbody th {
  border: 1px solid #4d4d4d;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
@media (max-width: 600px) {
  main h1 {
    font-size: 1.2rem;
  }
  main .select_row select {
    width: 60%;
    height: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/Fuel/styles/fuelSales.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EACI;IACI,wBAAA;EAIN;EADE;IACI,2BAAA;EAGN;EAAE;IACI,wBAAA;EAEN;AACF;AACA;;EAEI,aAAA;EACA,sBAAA;EACA,yBDlBS;ECmBT,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;AACJ;AAAI;;EACI,aAAA;EACA,WAAA;EACA,yBD7BI;EC8BJ,UAAA;AAGR;AAFQ;;EACI,qBAAA;AAKZ;AAJY;;EACI,eAAA;AAOhB;AANgB;;EACI,qBAAA;EACA,gBAAA;AASpB;AAJI;;EACI,eAAA;AAOR;AALI;;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAQR;AAPQ;;EACI,yBAAA;EACA,WAAA;AAUZ;AARQ;;EACI,yBAAA;EACA,WAAA;AAWZ;AATQ;;EACI,UAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;AAYZ;AAXY;;EACI,yBAAA;AAchB;AAXQ;;EACI,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAcZ;AAXI;;EACI,kBAAA;EACA,eAAA;AAcR;AAZI;;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAeR;AAdQ;;EACI,sBAAA;EACA,2CAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAiBZ;AAhBY;;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAmBhB;AAjBgB;;EACI,cDtGR;ECuGQ,cAAA;AAoBpB;AAjBY;;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,+BAAA;EACA,uCAAA;AAoBhB;AAjBQ;;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAoBZ;AAnBY;;EACI,sBAAA;EACA,2CAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;EACA,uBAAA;EACA,cAAA;AAsBhB;AArBgB;;EACI,yBAAA;AAwBpB;AAtBgB;;EACI,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,cDvIR;ACgKZ;AAxBoB;;EACI,yBAAA;AA2BxB;AAxBwB;;EACI,yBDhJhB;ECiJgB,WAAA;AA2B5B;AAvBwB;;EACI,yBAAA;EACA,eAAA;AA0B5B;AAxBwB;;EACI,uFAAA;AA2B5B;AAnBwB;;EACI,yBAAA;AAsB5B;AApBwB;;EACI,yBAAA;AAuB5B;AArBwB;;EACI,yBAAA;EACA,WAAA;AAwB5B;AAtBwB;;EACI,gEAAA;EAEA,+BAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;AAwB5B;AAtBwB;;EACI,yDAAA;EACA,mBAAA;EACA,4BAAA;EACA,4BAAA;AAyB5B;AAvBwB;;EACI,yBAAA;EACA,WAAA;AA0B5B;AArBY;;EACI,cAAA;AAwBhB;AAtBY;;EACI,eAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAyBhB;AAvBY;;EACI,UAAA;EACA,sBAAA;AA0BhB;;AApBA;EACI,uBAAA;AAuBJ;;AApBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AAuBJ;AAtBI;EACI,eAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAwBR;AAvBQ;EACI,cD3OA;EC4OA,eAAA;EACA,SAAA;AAyBZ;AArBI;EACI,yBDjPK;ACwQb;;AAnBI;EACI,aAAA;EACA,6BAAA;AAsBR;AArBQ;EACI,cD1PA;ACiRZ;AAnBI;EACI,gBAAA;EACA,gBAAA;AAqBR;AAnBQ;EACI,cDnQA;ACwRZ;AAjBY;EACI,oCAAA;AAmBhB;AAhBgB;EACI,cD5QR;EC6QQ,gBAAA;AAkBpB;;AAZA;EACI,aAAA;EACA,sBAAA;AAeJ;AAbI;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAeR;AAbI;EACI,WAAA;AAeR;AAZI;EACI,aAAA;EACA,6BAAA;AAcR;AAbQ;EACI,YAAA;AAeZ;;AAVA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAaJ;AAZI;EACI,SAAA;EACA,cD9SI;AC4TZ;AAZI;EACI,yBAAA;EACA,qBAAA;AAcR;AAZI;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;AAcR;AAbQ;EACI,cD5TA;AC2UZ;AAZI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;AAcR;AAbQ;EACI,yBDxUA;ECyUA,WAAA;AAeZ;AAZY;;EAEI,yBAAA;AAchB;;AARA;EACI;IAEI,kCAAA;EAUN;EAPE;IAEI,iCAAA;EAQN;EALE;IAGI,kCAAA;EAKN;EAFE;IAEI,iCAAA;EAGN;AACF;AAAA;EAEQ;IACI,iBAAA;EACV;EAGU;IACI,UAAA;IACA,YAAA;EADd;AACF","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../../variables.scss\";\n\n@keyframes upDown {\n    0% {\n        transform: translateY(0);\n    }\n\n    50% {\n        transform: translateY(-5px);\n    }\n\n    100% {\n        transform: translateY(0);\n    }\n}\n\nmain,\n.fuel {\n    display: flex;\n    flex-direction: column;\n    background-color: $background;\n    min-height: 62.1vh;\n    width: 100%;\n    margin: auto;\n    align-items: center;\n    justify-content: flex-start;\n    #context__menu {\n        display: none;\n        color: #fff;\n        background-color: $nitroDark;\n        width: 9vw;\n        ul {\n            list-style-type: none;\n            li {\n                cursor: pointer;\n                &:hover {\n                    transform: scale(1.2);\n                    transition: 0.5s;\n                }\n            }\n        }\n    }\n    h1 {\n        font-size: 2rem;\n    }\n    .select_row {\n        display: flex;\n        justify-content: space-around;\n        align-items: center;\n        width: 60vw;\n        margin: 0 auto;\n        .Compile_Done {\n            background-color: #71a621;\n            color: #fff;\n        }\n        .Compile__Error {\n            background-color: #f29f05;\n            color: #fff;\n        }\n        select {\n            width: 25%;\n            padding: 1%;\n            border-radius: 1rem;\n            background-color: #fff;\n            &:focus {\n                border: 1px solid $nitroLight;\n            }\n        }\n        input[type=\"date\"] {\n            border: none;\n            background-color: #fff;\n            border-radius: 1rem;\n            height: 4vh;\n        }\n    }\n    #loader {\n        align-self: center;\n        margin: 2% auto;\n    }\n    .info {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        margin-top: 1%;\n        width: 100vw;\n        overflow: hidden;\n        .info__card {\n            background-color: #fff;\n            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n            width: 80vw;\n            border-radius: 1rem;\n            height: 11vh;\n            display: flex;\n            justify-content: space-evenly;\n            align-items: center;\n            position: relative;\n            margin-bottom: 2%;\n            .card__till {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n\n                h3 {\n                    color: $fontColor;\n                    margin: 0 auto;\n                }\n            }\n            .info__card__icon {\n                position: absolute;\n                right: 2%;\n                bottom: 1.5%;\n                animation: upDown 1.5s infinite;\n                -webkit-animation: upDown 1.5s infinite;\n            }\n        }\n        .info__button {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: flex-start;\n            position: relative;\n            .info__expand {\n                background-color: #fff;\n                box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n                width: 95vw;\n                display: flex;\n                justify-content: space-evenly;\n                align-items: flex-start;\n                margin-top: 2%;\n                .compiled {\n                    border: 3px solid #22ff69;\n                }\n                table {\n                    border: 1px solid $fontColor;\n                    border-collapse: collapse;\n                    width: 100%;\n                    color: $fontColor;\n                    .compiled {\n                        border: 3px solid #22ff69;\n                    }\n                    thead {\n                        th {\n                            background-color: $nitroDark;\n                            color: #fff;\n                        }\n                    }\n                    tbody {\n                        tr {\n                            border: 1px solid $fontColor;\n                            cursor: pointer;\n                        }\n                        .noteAdded {\n                            background-image: linear-gradient(\n                                225deg,\n                                red,\n                                red 10px,\n                                transparent 10px,\n                                transparent\n                            );\n                        }\n                        .selected {\n                            background-color: #f2bc18;\n                        }\n                        .matched {\n                            background-color: #22ff69;\n                        }\n                        .matchedDiscrepancy {\n                            background-color: #038c3e;\n                            color: #fff;\n                        }\n                        .notmatched {\n                            animation: shake 0.82s\n                                cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n                            transform: translate3d(0, 0, 0);\n                            backface-visibility: hidden;\n                            perspective: 1000px;\n                            background-color: #d90d1e;\n                            color: #fff;\n                        }\n                        .bp__points {\n                            background-image: url(../images/bp.png);\n                            background-size: 5%;\n                            background-repeat: no-repeat;\n                            background-position-x: right;\n                        }\n                        .ignored {\n                            background-color: #5d5d5d;\n                            color: #fff;\n                        }\n                    }\n                }\n            }\n            button {\n                margin-top: 1%;\n            }\n            .help__icon {\n                position: fixed;\n                bottom: 4vh;\n                right: 3vw;\n                z-index: 10;\n            }\n            .tiny__loader {\n                width: 10%;\n                margin: 2% auto 0 auto;\n            }\n        }\n    }\n}\n\n.css-19kzrtu {\n    padding: 0px !important;\n}\n\n.suspended_fuel {\n    display: flex;\n    align-items: flex-start;\n    flex-direction: row;\n    text-align: center;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 10px;\n    padding: 0 2vw;\n    width: 100%;\n    margin-top: 1vh;\n    .suspend_card {\n        cursor: pointer;\n        width: 28vw;\n        background-color: white;\n        border-radius: 5px;\n        height: 20vh;\n        display: flex;\n        flex-direction: column;\n        h3 {\n            color: $nitroDark;\n            font-size: 2rem;\n            margin: 0;\n        }\n    }\n\n    .suspend_card:hover {\n        background-color: $nitroLight;\n    }\n}\n.suspend_modal {\n    .header_info {\n        display: flex;\n        justify-content: space-evenly;\n        span {\n            color: $nitroDark;\n        }\n    }\n\n    .transaction_accordians {\n        max-height: 60vh;\n        overflow-y: auto;\n\n        .no_transactions {\n            color: $nitroDark;\n        }\n\n        .transaction_accordian {\n            &.Mui-disabled {\n                background-color: rgba(255, 255, 255, 1);\n            }\n            .transaction_heading {\n                span {\n                    color: $nitroDark;\n                    font-weight: 700;\n                }\n            }\n        }\n    }\n}\n.tender_modal {\n    display: flex;\n    flex-direction: column;\n\n    .modal_content {\n        margin: 10px;\n        font-size: 1.2rem;\n        text-align: center;\n        font-weight: 500;\n    }\n    .alert_section {\n        height: 6vh;\n    }\n\n    .btn_section {\n        display: flex;\n        justify-content: space-around;\n        button {\n            width: 200px;\n        }\n    }\n}\n\n.force__match {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    p {\n        margin: 0;\n        color: $fontColor;\n    }\n    select {\n        border: 1px solid $nitroDark;\n        border-radius: 0.5rem;\n    }\n    .force__buttons {\n        display: flex;\n        justify-content: space-evenly;\n        align-items: center;\n        width: 80%;\n        margin: auto;\n        margin-top: 1%;\n        table {\n            color: $fontColor;\n        }\n    }\n    table {\n        width: 100%;\n        margin: auto;\n        border: 1px solid $fontColor;\n        border-collapse: collapse;\n        thead {\n            background-color: $nitroDark;\n            color: #fff;\n        }\n        tbody {\n            tr,\n            th {\n                border: 1px solid $fontColor;\n            }\n        }\n    }\n}\n\n@keyframes shake {\n    10%,\n    90% {\n        transform: translate3d(-1px, 0, 0);\n    }\n\n    20%,\n    80% {\n        transform: translate3d(2px, 0, 0);\n    }\n\n    30%,\n    50%,\n    70% {\n        transform: translate3d(-4px, 0, 0);\n    }\n\n    40%,\n    60% {\n        transform: translate3d(4px, 0, 0);\n    }\n}\n\n@media (max-width: $mobile) {\n    main {\n        h1 {\n            font-size: 1.2rem;\n        }\n\n        .select_row {\n            select {\n                width: 60%;\n                height: 2rem;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
